<template>
  <div class="container">
    <a-layout-content>
      <div class="mb-24">
        <T1BreadcrumbsPlaceholder v-if="!titleReady" />
        <T1Breadcrumbs
          v-show="titleReady"
          :activeTail="false"
          :homeLink="true"
          :extraItem="addExtraItems()"
          :locid="locid"
          :guide="true"
        />
      </div>
      <div class="mb-12">
        <a-row :gutter="16" type="flex" align="bottom">
          <a-col :md="17">
            <div class="offer-title">
              <div
                v-if="!titleReady"
                class="title-placeholder placeholder-animated"
              ></div>
              <h1 v-else class="offer-title__heading">{{ geoname }}</h1>
            </div>
          </a-col>
        </a-row>
      </div>
      <a-row :gutter="32" class="mb-48">
        <a-col
          :lg="16"
          :xl="17"
          itemtype="https://schema.org/Article"
          itemscope="1"
        >
          <meta
            itemtype="https://schema.org/WebPage"
            itemprop="mainEntityOfPage"
            itemscope="1"
          />
          <meta itemprop="headline" :content="geoname" />
          <div
            itemtype="https://schema.org/Organization"
            itemprop="publisher"
            itemscope="1"
          >
            <meta :content="serwis" itemprop="name" />
          </div>
          <T1GeoPrzewodnikCarousel
            :topOffersExists="showOffers()"
            :cheapestOfferPrice="cheapestOfferPrice"
            :clocid="countrylocid"
            :geolocid="locid"
            :locidname="geoname"
            class="mb-32"
          />
          <T1ForecastWidget :wname="geoname" />
          <div class="layout-segment">
            <div class="">
              <T1GeoPrzewodnikOpisy
                :opisy="sekcje"
                :mapCoords="getMapCoords()"
                :geolocid="getGeoLocid()"
                :hasCoords="hasCoords"
                :descriptionsData="descriptionsData"
                :aZInfoData="aZInfoData"
                :practicalInfoData="practicalInfoData"
              />
            </div>
          </div>
        </a-col>

        <a-col :md="24" :lg="8" :xl="7">
          <div class="aside-segment">
            <template v-if="regiony.length != 0">
              <T1GeoTree :regiony="regiony" v-if="locid" :locid="locid" />
            </template>
          </div>

          <div class="aside-segment" v-if="showOffers()">
            <h3 class="aside-segment__title">Oferty w okolicy</h3>
            <a-row :gutter="[24, 24]">
              <a-col :xs="24" :sm="12" :lg="24">
                <T1TopOfferCard :oferta="getOfertyItems(0)" />
              </a-col>
              <a-col :xs="24" :sm="12" :lg="24">
                <T1TopOfferCard :oferta="getOfertyItems(1)" />
              </a-col>
              <a-col :xs="24" :sm="12" :lg="24">
                <T1TopOfferCard :oferta="getOfertyItems(2)" />
              </a-col>
              <a-col :xs="24" :sm="12" :lg="24">
                <T1TopOfferCard :oferta="getOfertyItems(3)" />
              </a-col>
            </a-row>
          </div>
        </a-col>
      </a-row>
    </a-layout-content>
  </div>
</template>

<script>
import axios from "axios";
import * as CONFIG from "./config.js";
import T1BreadcrumbsPlaceholder from "./T1Placeholders/T1BreadcrumbsPlaceholder";
import T1Breadcrumbs from "./T1Breadcrumbs/T1Breadcrumbs";
// import T1GeoPrzewodnikRegions from "./T1GeoPrzewodnikRegions";
import T1GeoPrzewodnikCarousel from "./T1GeoPrzewodnikCarousel";
import T1GeoPrzewodnikOpisy from "./T1GeoPrzewodnikOpisy";
import T1GeoTree from "./T1GeoTree/T1GeoTree";
import T1ForecastWidget from "./T1PogodaKlimat/T1ForecastWidget";
import T1TopOfferCard from "./T1OfferCards/T1TopOfferCard";
import { relativeTimeRounding } from "moment";
//import T1GeoPrzewodnik from './T1GeoPrzewodnik';

export default {
  name: "przewodnik-content",
  data: () => ({
    url: "/getprzewodniklocid.json",
    opisurl: "/getprzewodnikopis.json",
    treeurl: "/getprzewodnikgeotree.json",
    topoffersurl: "/vueoffers.json",
    params: "&panstwo=" + CONFIG.panstwo_kod,
    items: [],
    geotree: {},
    geoname: "",
    locid: "",
    countrylocid: CONFIG.locid,
    opis: {},
    sekcje: [],
    regiony: [],
    topoffers: [],
    cheapestOfferPrice: "",
    mtitle: "",
    mdescription: "",
    hasCoords: true,
    regionsUrls: [],
    serwis: CONFIG.serwis,
    mapCoords: [],
    descriptionsData: [],
    aZInfoData: [],
    practicalInfoData: [],
    breadcrumbsReady: false,
    titleReady: false,
  }),
  methods: {
    addExtraItems() {
      let extraItems = [];

      extraItems.push({
        name: "Przewodnik turystyczny",
        link: this.getGuidePageUrl(),
      });
      return extraItems;
    },
    getPageUrl() {
      return window.location;
    },
    getGuidePageUrl() {
      return "/" + CONFIG.panstwo_id + "-przewodnik-turystyczny.xml";
    },
    showOffers() {
      return this.topoffers.length > 0;
    },
    getTopOffers() {
      var pars = "top=10&locid=" + this.locid;
      return axios
        .get(CONFIG.API_URL + this.topoffersurl + "?" + pars, null, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json",
          },
        })
        .then((response) => {
          //alert("DATA ITEMS:" + JSON.stringify(response.data));
          return response.data;
        })
        .catch((e) => {
          alert("ERROR" + e);
        });
    },
    getGeoItems() {
      var pars = "surl=" + this.$route.path + this.params;
      return axios
        .get(CONFIG.API_URL + this.url + "?" + pars, null, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json",
          },
        })
        .then((response) => {
          /*alert("DATA:" + response.data);
               alert("STATUS:" + response.status);*/
          //alert("DATA ITEMS:" + JSON.stringify(response.data));
          return response.data;
        })
        .catch((e) => {
          alert("ERROR" + e);
        });
    },
    getGeoOpis() {
      var pars = "locid=" + this.locid;
      return axios
        .get(CONFIG.API_URL + this.opisurl + "?" + pars, null, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json",
          },
        })
        .then((response) => {
          /*alert("DATA:" + response.data);
               alert("STATUS:" + response.status);*/
          //alert("DATA ITEMS:" + JSON.stringify(response.data));
          return response.data;
        })
        .catch((e) => {
          alert("ERROR" + e);
        });
    },
    getGeoTree() {
      var pars = "locid=" + this.countrylocid;
      return axios
        .get(CONFIG.API_URL + this.treeurl + "?" + pars, null, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json",
          },
        })
        .then((response) => {
          /*alert("DATA:" + response.data);
               alert("STATUS:" + response.status);*/
          //alert("DATA ITEMS:" + JSON.stringify(response.data));
          return response.data;
        })
        .catch((e) => {
          alert("ERROR" + e);
        });
    },
    getParentUrl() {
      return this.parentURL;
    },
    getOfertyItems(i) {
      if (this.topoffers.length > i) {
        return this.topoffers[i];
      } else {
        return {};
      }
    },
    getMapCoords() {
      return this.mapCoords;
    },
    getGeoLocid() {
      return this.locid;
    },
    getOpisy(locid) {
      let that = this;
      let insUrl = CONFIG.API_URL + "/getprzewodnikopis.xml?locid=" + locid;
      jQuery.ajax({
        url: insUrl,
        dataType: "xml",
        success: function (data) {
          let xmlObj = jQuery(data);
          let dataArr = [];

          xmlObj.find("Sekcja").each(function (index, elem) {
            if (elem.attributes.tytul) {
              let title = elem.attributes.tytul.nodeValue;

              xmlObj.find("link").each(function () {
                var link = jQuery(this).attr("to");
                var linkTxt = jQuery(this).html();
                jQuery(this).replaceWith(
                  '<a href="' + link + '">' + linkTxt + "</a>"
                );
              });

              let text = jQuery(elem).html();
              dataArr.push({ title: title, content: text });
            }
          });

          that.descriptionsData = dataArr;

          if (!dataArr.length) {
            let offerValues = "";
            let offerRecommendation = "";

            xmlObj.find("Walor").each(function (index, elem) {
              let content = "<li>" + jQuery(elem).text() + "</li>";
              offerValues += content;
            });

            if (offerValues != "") {
              dataArr.push({
                title: "Walory",
                content: "<ul>" + offerValues + "</ul>",
              });
            }

            if (xmlObj.find("Polecamy").length > 0) {
              var pol = xmlObj.find("Polecamy")[0];
              if (jQuery(pol).text() !== "") {
                xmlObj.find("Polecamy").each(function (index, elem) {
                  let content = "<li>" + jQuery(elem).text() + "</li>";
                  offerRecommendation += content;
                });

                dataArr.push({
                  title: "Polecamy",
                  content: "<ul>" + offerRecommendation + "</ul>",
                });
              }
            }
          }

          let regionLeadTxt = xmlObj.find("Lead").text();
          jQuery(".lead--text").append(regionLeadTxt);
        },
        error: function (e) {
          console.log("Ajax Error" + e);
        },
      });
    },
    getAZOpisy(locid) {
      let that = this;
      var insUrl = CONFIG.API_URL + "/getprzewodnikaz.xml?locid=" + locid;
      jQuery.ajax({
        url: insUrl,
        dataType: "xml",
        success: function (data) {
          let xmlObj = jQuery(data);
          let dataArr = [];

          xmlObj.find(".detail-info-list li").each(function (index, elem) {
            let title = jQuery(elem).find("h3").text();
            let content = jQuery(elem).find("p").html();

            xmlObj.find("link").each(function () {
              var link = jQuery(this).attr("to");
              var linkTxt = jQuery(this).html();
              jQuery(this).replaceWith(
                '<a href="' + link + '">' + linkTxt + "</a>"
              );
            });

            if (jQuery(elem).find("h3").length > 0) {
              dataArr.push({ title: title, content: content });
            }
          });

          that.aZInfoData = dataArr;
        },
        error: function (e) {
          console.log("Ajax Error" + e);
        },
      });
    },

    getPracticalInfo(locid) {
      let that = this;
      let insUrl = CONFIG.API_URL + "/getprzewodnikinfprk.xml?locid=" + locid;
      jQuery.ajax({
        url: insUrl,
        dataType: "xml",
        success: function (data) {
          let xmlObj = jQuery(data);
          let dataArr = [];
          let contentArr = [];
          let tocArr = [];

          xmlObj.find(".detail-list-holder ul").each(function (index, elem) {
            let toc = elem.outerHTML;
            tocArr.push({ toc: toc });
          });

          xmlObj.find(".detail-list-holder h3").each(function (index, elem) {
            let title = xmlObj.find("h3:eq(" + index + ")").text();
            dataArr.push({ title: title, content: "" });
          });

          xmlObj.find(".detail-info-list").each(function (index, elem) {
            let content;

            xmlObj.find("link").each(function () {
              var link = jQuery(this).attr("to");
              var linkTxt = jQuery(this).html();
              jQuery(this).replaceWith(
                '<a href="' + link + '">' + linkTxt + "</a>"
              );
            });

            xmlObj.find(".link-up").each(function () {
              jQuery(this).remove();
            });
            content = elem.outerHTML;
            contentArr.push({ content: content });
          });

          dataArr.forEach(function (obj, idx) {
            obj.content = contentArr[idx].content;
            obj.toc = tocArr[idx].toc;
          });

          that.practicalInfoData = dataArr;
        },
        error: function (e) {
          console.log("Ajax Error" + e);
        },
      });
    },
  },
  mounted() {
    var that = this;
    this.getGeoItems().then((data) => {
      that.items = data.page.LocIndeks;
      that.locid = data.page.LocIDMap.row.locid;
      //console.log(that.locid);

      that.getGeoOpis().then((data2) => {
        that.opis = data2.page.Lokalizacja;
        if (data2.page.Lokalizacja.Sekcje instanceof Array) {
          that.sekcje = data2.page.Lokalizacja.Sekcje;
        } else {
          var sekcjeArr = [];
          sekcjeArr.push(data2.page.Lokalizacja.Sekcje);
          that.sekcje = sekcjeArr;
        }
        //console.log(that.opis.wlocName);
        that.geoname = that.opis.wlocName;
        var pol = that.opis.Polozenie;
        var mtitle = "";
        var mdesc = "";
        var lgeodata = [];
        var lgeoObj = {};
        if (pol.Country && pol.Country.locID == that.locid) {
          mtitle = pol.Country["meta-title"];
          mdesc = pol.Country["meta-description"];
          lgeoObj.lat = pol.Country.ltd;
          lgeoObj.lng = pol.Country.lng;
          lgeoObj.zoom = pol.Country.zoom;
          lgeoObj.typMapy = pol.Country.typMapy;
        } else if (pol.Region && pol.Region.locID == that.locid) {
          mtitle = pol.Region["meta-title"];
          mdesc = pol.Region["meta-description"];
          lgeoObj.lat = pol.Region.ltd;
          lgeoObj.lng = pol.Region.lng;
          lgeoObj.zoom = pol.Region.zoom;
          lgeoObj.typMapy = pol.Region.typMapy;
        } else if (pol.Miniregion && pol.Miniregion.locID == that.locid) {
          mtitle = pol.Miniregion["meta-title"];
          mdesc = pol.Miniregion["meta-description"];
          lgeoObj.lat = pol.Miniregion.ltd;
          lgeoObj.lng = pol.Miniregion.lng;
          lgeoObj.zoom = pol.Miniregion.zoom;
          lgeoObj.typMapy = pol.Miniregion.typMapy;
        }
        if (Object.keys(lgeoObj).length === 0) {
          that.hasCoords = false;
        }
        lgeodata.push(lgeoObj);
        this.mapCoords = lgeodata;
        // if (that.geoname != "") {
        //   that.$root.$emit("update:hotel", that.geoname);
        // }
        if (mtitle != "") {
          that.mtitle = mtitle;
          that.$root.$emit("update:mtitle", that.mtitle);
        } else {
          that.$root.$emit("update:geoname", that.geoname);
        }
        if (mdesc != "") {
          that.mdescription = mdesc;
          that.$root.$emit("update:mdesc", that.mdescription);
        }
        that.getOpisy(that.locid);
      });

      that.getTopOffers().then((data3) => {
        that.topoffers = data3.page.response;

        if (that.topoffers.length) {
          this.cheapestOfferPrice = that.topoffers
            .map(function (elem) {
              return elem.ofr.price;
            })
            .reduce(function (elem) {
              return Math.min(elem).toString();
            });
        }
      });
      this.getGeoTree().then((data) => {
        that.geotree = data.geotree.Country;
        that.regiony = that.geotree.Region;
      });
      this.getAZOpisy(this.locid);
      this.getPracticalInfo(this.locid);
    });
    this.$root.$on("update:breadcrumbsReady", (val1) => {
      that.breadcrumbsReady = val1;
    });
  },
  updated() {
    if (this.breadcrumbsReady && this.geoname) {
      this.titleReady = true;
    }
  },
  components: {
    T1BreadcrumbsPlaceholder,
    T1Breadcrumbs,
    // T1GeoPrzewodnikRegions,
    T1GeoPrzewodnikCarousel,
    T1GeoPrzewodnikOpisy,
    T1GeoTree,
    T1ForecastWidget,
    T1TopOfferCard,
  },
};
</script>

<style lang="scss" scoped>
.offer-title {
  &__heading {
    font-size: 24px;
    margin-bottom: 0;
  }
}

.aside-segment {
  margin-bottom: 24px;
}

.title-placeholder {
  width: 280px;
  height: 30px;
}
</style>
